function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.20848,
  y: 2.48509,
  width: 50.9815,
  height: 52.5418,
  rx: 25.4908,
  stroke: "white",
  strokeWidth: 3.45797
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.3495 40.6249V29.3606H33.2098L33.788 24.8779H29.3495V22.0166C29.3495 20.7198 29.7103 19.8359 31.5711 19.8359L33.944 19.8343V15.8259C33.5328 15.7707 32.1242 15.6494 30.4855 15.6494C27.0648 15.6494 24.7218 17.7371 24.7218 21.5738V24.8779H20.8521V29.3606H24.7218V40.6249H29.3495Z",
  fill: "white"
});

var SvgIcFb = function SvgIcFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-fb.7f7f01b5.svg";
export { ForwardRef as ReactComponent };